import { render, staticRenderFns } from "./CookieBanner.vue?vue&type=template&id=600edf84&scoped=true"
import script from "./CookieBanner.vue?vue&type=script&lang=js"
export * from "./CookieBanner.vue?vue&type=script&lang=js"
import style0 from "./CookieBanner.vue?vue&type=style&index=0&id=600edf84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600edf84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('600edf84')) {
      api.createRecord('600edf84', component.options)
    } else {
      api.reload('600edf84', component.options)
    }
    module.hot.accept("./CookieBanner.vue?vue&type=template&id=600edf84&scoped=true", function () {
      api.rerender('600edf84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/CookieBanner/CookieBanner.vue"
export default component.exports